import {
    Typography, Box, Grid, TextField, Checkbox, Button, Dialog,
    DialogActions, DialogContent, DialogTitle, Link, InputAdornment, Snackbar, Paper, IconButton
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import React, { useContext, useState, useEffect } from "react";
import { makeStyles } from "@mui/styles";
import { Divider } from '@mui/material';
import { getStudentInfo } from "../../../../../Utils/apiService";
import { getUserDetails } from "../../../../../storageService";
import { AuthContext } from "../../../../../Helpers/Contexts/authContext";
import { AuthUser } from "../../../../../interfaces/Contexts";
import DefaultProfileImage from '../../../../../Assets/image1.png';
import KenLoader from "../../../../Events/globalComponent/KenLoader";
import { useNavigate } from "react-router-dom";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CloseIcon from "@mui/icons-material/Close";
import { saveStudentProfileInfo } from '../../../../../Utils/apiService'
import { enqueueSnackbar } from 'notistack';
import routes from "../../../../../Utils/routes";
// import PasswordEditDialog from "./passworddialog"; 




const useStyles = makeStyles(() => ({
    resourceContainer: {
        background: "white",
        borderRadius: "12px",
        padding: 16,
        marginBottom: 16,
        display: "flex",
        flexDirection: "column",
        height: '84vh !important',
        overflowY: 'scroll',
        '&::-webkit-scrollbar': { display: 'none' },
        '&::-webkit-scrollbar-thumb': { background: '#A0A0A0', borderRadius: '10px' },
    },

    userInfo: {
        display: "flex",
        flexDirection: "column",
        paddingLeft: '20px',
    },
    userName: {
        fontWeight: '600 !important',
        fontSize: "24px",
        color: 'black',
        textAlign: 'left',
        paddingBottom: '5px'

    },
    userId: {
        fontSize: "18px",
        color: "#373A45",
        fontWeight: '400 !important',
        textAlign: 'left',
        paddingBottom: '5px'
    },
    infoBox: {
        display: 'flex',
        gap: 160,
        marginTop: '16px',
    },
    infoLabel: {
        color: ' #8C8E94',
        fontSize: '14px',
        textAlign: 'left',
        fontWeight: '500 !important',
        paddingBottom: '5px',
        paddingTop: '15px'
    },
    infoValue: {
        color: 'black',
        fontWeight: '450 !important',
        fontSize: '16px',
    },
    statusBadge: {
        backgroundColor: '#E8F5EC',
        color: '#2E9E52',
        padding: '4px 12px',
        borderRadius: '16px',
        fontSize: '12px',
        fontWeight: '400',
    },
    dividerresact: {
        width: '100%',
        height: "2px",
        background: 'linear-gradient(270deg, rgba(191, 206, 255, 0) 0%, #B8DCF0 100%)',
        margin: "20px",
    },
    bioSection: {
        marginTop: '20px',
    },
    bioInput: {
        width: '100%',
        marginBottom: '16px',
    },
    editLink: {
        cursor: 'pointer',
        color: '#1273BC',
        marginLeft: '8px',
    },
    checkboxContainer: {
        display: 'flex',
        alignItems: 'center',
        marginTop: '8px',
    },
    buttonContainer: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginTop: '16px',
    },
    inputContainer: {
        display: 'grid',
        gridTemplateColumns: 'repeat(4, 1fr)',
        gap: '40px',
        marginTop: '16px',

    },
    inputField: {
        height: '48px',
        borderRadius: '16px !important',
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#B2B3B7 !important',
        },
        '& .MuiOutlinedInput-input': {
            color: '#8C8E94 !important',
        },
        padding: '10px 0px 10px 0px !important'
    },

    divider: {
        background: '#B8DCF0',
        height: '2px',
        margin: '16px 0',
        padding: '10px',
        marginBottom: '16px',
        marginTop: '16px'
    },
    dividercolor: {
        background: 'linear-gradient(270deg, rgba(191, 206, 255, 0.5) 0%, #B8DCF0 100%) !important',
        height: '2px',
        margin: '16px 0',


    },

}));


const EditProfile: React.FC = () => {
    interface Address {
        add?: {
            House_Flat_No__c?: string;
            Is_Permanent_Address_Same__c?: string;
            hed__Address_Type__c?: string;
            hed__MailingStreet__c?: string;
            hed__MailingCity__c?: string;
            hed__MailingState__c?: string;
            hed__MailingPostalCode__c?: string;
        };
    }

    const { state: { user }, } = useContext(AuthContext);
    const userData = user as AuthUser;
    const classes = useStyles();
    const [dialogOpen, setDialogOpen] = useState(false);
    const [editField, setEditField] = useState("");
    const [editValue, setEditValue] = useState("");
    const [discardDialogOpen, setDiscardDialogOpen] = useState(false);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState("");
    const [snackbarDescription, setSnackbarDescription] = useState("");
    const [hidePhone, setHidePhone] = useState(false);
    const [hideEmail, setHideEmail] = useState(false);
    const [loader, setLoader] = useState(false);
    const [update, setUpdate] = useState(false)
    const [isDialogOpen, setIsDialogOpen] = useState(false);


    const navigate = useNavigate();


    const [isEditable, setIsEditable] = useState(false);

    const handleEditClick = (label: string, value: string) => {
        setEditField(label);
        setEditValue(value);
        setDialogOpen(true);
    };

    const handleOkClick = () => {
        setStudentInfo({ ...studentInfo, [editField]: editValue });
        setDialogOpen(false);
    
       
        let message = '';
        if (editField === 'Phone') {
            message = 'Phone Number has been updated';
        } else if (editField === 'Email') {
            message = 'Email has been updated';
        }
    
        setSnackbarMessage(message);
        setSnackbarOpen(true);
    };
    const handleCancelClick = () => {
        setDialogOpen(false);
      
        // Check if the value was changed before canceling
        if (editField in studentInfo && studentInfo[editField as keyof typeof studentInfo] === editValue) {
          setSnackbarMessage('No changes made');
          setSnackbarOpen(true);
        }
      };
    const initialStudentInfo = {
        Profile: "",
        fullName: "",
        firstName: "",
        lastName: "",
        Gender: "",
        birthPlace: "",
        dob: "",
        nationality: "",
        countryOfResidence: "",
        Phone: "",
        Email: "",
        BloodGroup: "",
        houseNoPermanent: "",
        streetPermanent: "",
        suburbPermanent: "",
        cityPermanent: "",
        pincodePermanent: "",
        houseNoCurrent: "",
        streetCurrent: "",
        suburbCurrent: "",
        cityCurrent: "",
        pincodeCurrent: "",
        aadharNumber: "",
        role: "",
        Program: "",
        Id: "",
        password: "",
        status: ""
    };
    const [studentInfo, setStudentInfo] = useState(initialStudentInfo)
    const [loading, setLoading] = useState<boolean>(true);
    const [formData, setFormData] = useState(studentInfo);
    const [error, setError] = useState<string | null>(null);
    const [ContactId, setContactId] = useState<string | null>(null);
    const [activeTab, setActiveTab] = useState(0);
    const [passwords, setPasswords] = useState<{ currentPassword: string; newPassword: string }>({
        currentPassword: "",
        newPassword: "",
    });
    const [errors, setErrors] = useState<{ newPassword: string }>({
        newPassword: "",
    });

    const validatePassword = (password: string) => {
        const minLength = /.{8,}/;
        const uppercase = /[A-Z]/;
        const lowercase = /[a-z]/;
        const number = /\d/;
        const specialChar = /[@#$%^&*()_+=[\]{};':"\\|,.<>?]/;
        const noWhitespace = /^\S*$/;

        if (!minLength.test(password)) return "Password must be at least 8 characters long.";
        if (!uppercase.test(password)) return "Password must contain at least one uppercase letter.";
        if (!lowercase.test(password)) return "Password must contain at least one lowercase letter.";
        if (!number.test(password)) return "Password must contain at least one number.";
        if (!specialChar.test(password)) return "Password must contain at least one special character.";
        if (!noWhitespace.test(password)) return "Password must not contain whitespace.";

        return "";
    };



    const [showPassword, setShowPassword] = useState<{ current: boolean; new: boolean }>({
        current: false,
        new: false,
    });


    useEffect(() => {
        const userDetails = getUserDetails();
        if (userDetails?.ContactId) {
            getStudentInfo(userDetails.ContactId)
                .then((data) => {
                    const addresses: Address[] = Array.isArray(data?.address) ? data.address : [];

                    const permanentAddressObj = addresses.find((addr: Address) => addr.add?.hed__Address_Type__c === "Permanent");
                    const isPermanentSame = permanentAddressObj?.add?.Is_Permanent_Address_Same__c === "YES";


                    const currentAddressObj = isPermanentSame
                        ? permanentAddressObj
                        : addresses.find((addr: Address) => addr.add?.hed__Address_Type__c === "Current") || null;
                    setStudentInfo({
                        Profile: data?.profile,
                        aadharNumber: data?.aadharNumber,
                        fullName: `${data?.firstName} ${data?.lastName}`,
                        firstName: data?.firstName,
                        lastName: data?.lastName,
                        Gender: data?.Gender,
                        birthPlace: data?.birthPlace,
                        dob: data?.BirthDate,
                        nationality: data?.nationality,
                        countryOfResidence: data?.CountryOfResidence,
                        Phone: data?.Phone || "",
                        Email: data?.Email || "",
                        BloodGroup: data?.bloodGroup,
                        Program: data?.courseList,
                        Id: data?.registrationId,
                        status: data?.status,
                        password: data?.password,

                        houseNoPermanent: permanentAddressObj?.add?.House_Flat_No__c || "",
                        streetPermanent: permanentAddressObj?.add?.hed__MailingStreet__c || "",
                        suburbPermanent: permanentAddressObj?.add?.hed__MailingCity__c || "",
                        cityPermanent: permanentAddressObj?.add?.hed__MailingState__c || "",
                        pincodePermanent: permanentAddressObj?.add?.hed__MailingPostalCode__c || "",


                        houseNoCurrent: currentAddressObj?.add?.House_Flat_No__c || "",
                        streetCurrent: currentAddressObj?.add?.hed__MailingStreet__c || "",
                        suburbCurrent: currentAddressObj?.add?.hed__MailingCity__c || "",
                        cityCurrent: currentAddressObj?.add?.hed__MailingState__c || "",
                        pincodeCurrent: currentAddressObj?.add?.hed__MailingPostalCode__c || "",

                        role: data?.recordType
                    });
                })
                .catch(() => setError("Failed to load student details."))
                .finally(() => setLoading(false));
            setContactId(userDetails?.ContactId)
        }
    }, []);

    if (loading) return <KenLoader />;
    if (error) return <Typography color="error">{error}</Typography>;
    const Program = studentInfo.Program.charAt(0).toUpperCase() + studentInfo.Program.slice(1).toLowerCase();

    const handleChange = (field: "currentPassword" | "newPassword") => (e: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = e.target;
        setPasswords((prev) => ({ ...prev, [field]: value }));

        if (field === "newPassword") {
            const errorMessage = validatePassword(value);
            setErrors((prev) => ({ ...prev, newPassword: errorMessage }));
        }
    };

    // Toggle password visibility
    const togglePasswordVisibility = (field: "current" | "new") => {
        setShowPassword((prev) => ({ ...prev, [field]: !prev[field] }));
    };

    const handleDone = () => {
        console.log("Updated Passwords:", passwords);
        setStudentInfo((prev) => ({ ...prev, password: passwords.newPassword }));
        enqueueSnackbar("Password updated successfully", {
            variant: "success",
            autoHideDuration: 2000,
            anchorOrigin: {
                vertical: "top",
                horizontal: "center",
            },
        });
        setIsDialogOpen(false);
    };



    console.log("contactiduser", ContactId)
    const handleSave = () => {
        console.log('handleSave');


        setLoader(true);
        const updatedStudentInfo: any = {
            BirthDate: studentInfo.dob,
            CountryOfResidence: studentInfo.countryOfResidence,
            firstName: studentInfo.firstName,
            lastName: studentInfo.lastName,
            Gender: studentInfo.Gender,
            ContactId: ContactId,
            profile: studentInfo.Profile,
            aadharNumber: studentInfo.aadharNumber,
            birthPlace: studentInfo.birthPlace,
            bloodGroup: studentInfo?.BloodGroup,
            status: studentInfo.status,
            role: studentInfo.role,
            courseList: studentInfo?.Program,
            houseNoPermanent: studentInfo.houseNoPermanent,
            streetPermanent: studentInfo.streetPermanent,
            suburbPermanent: studentInfo.suburbPermanent,
            cityPermanent: studentInfo.cityPermanent,
            pincodePermanent: studentInfo.pincodePermanent,
            password: studentInfo.password,
            Phone: studentInfo.Phone,
            nationality: studentInfo.nationality,
            newpassword: passwords.newPassword,
            registrationId: studentInfo.Id,
email:studentInfo.Email,
            houseNoCurrent: studentInfo.houseNoCurrent,
            streetCurrent: studentInfo.streetCurrent,
            suburbCurrent: studentInfo.suburbCurrent,
            cityCurrent: studentInfo.cityCurrent,
            pincodeCurrent: studentInfo.pincodeCurrent,
        };

        if (editField === "Phone") {
            updatedStudentInfo.Phone = editValue;
        } else if (editField === "Phone") {
            updatedStudentInfo.Phone = studentInfo.Phone;
        }
        if (editField === "Phone" && studentInfo.Email !== editValue) {
            updatedStudentInfo.Email = studentInfo.Email;
        }

        if (editField === "Email" && studentInfo.Phone !== editValue) {
            updatedStudentInfo.Phone = studentInfo.Phone;
        }
        if (editField === "Password" && studentInfo.password !== editValue) {
            updatedStudentInfo.Password = studentInfo.password;
        }

        console.log("updatedStudentInfo", updatedStudentInfo);

        saveStudentProfileInfo(updatedStudentInfo)
            .then((data) => {
                console.log('data-no error', data);
                setSnackbarMessage('Profile updated successfully');
                setUpdate(false);
                setLoader(false);
                setStudentInfo((prev) => ({
                    ...prev,
                    Phone: updatedStudentInfo.Phone,
                    Email: updatedStudentInfo.Email,
                    password: updatedStudentInfo.password,

                }));

                // alert("Profile updated successfully");
                // setDialogOpen(false);
                setSnackbarMessage("Personal Details has been updated successfully.");
                setSnackbarOpen(true);
                setTimeout(() => {
                    navigate(routes.myProfile, { state: { activeTab: 1 } });
                }, 2000);

            })
            .catch((err) => {
                console.log('data-err', err.message);
                setSnackbarMessage('Failed to update profile');
                setLoader(false);
                setUpdate(true);

                alert("Failed to save profile. Please try again.");
            });
    };
    const handleConfirmDiscard = () => {
        navigate(-1); 
        setDiscardDialogOpen(false);
        setSnackbarMessage("Changes discarded");
        setSnackbarDescription("Your changes were successfully discarded.");
        setSnackbarOpen(true);
        setFormData(studentInfo);
     
    };




    return (
        <Box className={classes.resourceContainer}>
            <Grid item display="flex" flexDirection='row' alignItems="center">
                <Box>
                    <img
                        src={studentInfo.Profile ? studentInfo.Profile : DefaultProfileImage}
                        alt="profile"
                        style={{ width: '200px', height: '200px', cursor: 'pointer', borderRadius: '10px' }}
                    />


                </Box>
                <Box className={classes.userInfo}>
                    <Typography className={classes.userName}>
                        {studentInfo.fullName}
                    </Typography>
                    <Typography className={classes.userId}>
                        {studentInfo.Id}
                    </Typography>
                    <Box className={classes.infoBox}>
                        <Box>
                            <Typography className={classes.infoLabel}>Program</Typography>
                            <Typography className={classes.infoValue}>{Program}</Typography>
                        </Box>
                        <Box>
                            <Typography className={classes.infoLabel}>Role</Typography>
                            <Typography className={classes.infoValue}>{studentInfo.role}</Typography>
                        </Box>

                        <Box>
                            <Typography className={classes.infoLabel}>Status</Typography>
                            <Typography className={classes.statusBadge}>{studentInfo.status}</Typography>
                        </Box>
                    </Box>
                </Box>
            </Grid>
            <Box >
                <Typography sx={{
                    textAlign: "left", paddingTop: '15px', marginBottom: '16px', fontSize: '20px', fontWeight: '600 !important', color: '#373A45'
                }}>
                    Personal Details
                </Typography>

            </Box>
            <Divider className={classes.dividercolor} />
            <Box >
                <Typography className={classes.infoLabel}>
                    Bio
                </Typography>
            </Box>
            <Box className={classes.inputContainer}>
                {[['ID card name', studentInfo.fullName], ['Gender', studentInfo.Gender], ['Date of birth', studentInfo.dob], ['Nationality', studentInfo.nationality], ['Country of residence', studentInfo.countryOfResidence], ['Birth place', studentInfo.birthPlace]].map(([label, value]) => (
                    <Box key={label}>
                        <Typography sx={{ color: '#373A45!important' }} className={classes.infoLabel}>{label}</Typography>
                        <TextField size="small" fullWidth className={classes.inputField} value={value} sx={{ color: '#8C8E94 !important' }} disabled />
                    </Box>
                ))}
            </Box>
            <Divider className="divider" />

            <Box>
                <Box className={classes.inputContainer}>
                    {([
                        ['Phone', studentInfo.Phone, hidePhone],
                        ['Email', studentInfo.Email, hideEmail]
                    ] as const).map(([label, value, isHidden]) => (
                        <Box key={label as string}>
                            <Typography sx={{ color: '#373A45!important' }} className={classes.infoLabel}>
                                {label}
                            </Typography>
                            <Box display="flex" alignItems="center">
                                <TextField
                                    size="small"
                                    fullWidth
                                    className={classes.inputField}
                                    value={isHidden ? '**********' : value}
                                    sx={{ color: '#8C8E94 !important' }}
                                    disabled={!isEditable || Boolean(isHidden)}
                                    onChange={(e) => setStudentInfo({
                                        ...studentInfo,
                                        [label as string]: e.target.value
                                    })}
                                    InputProps={{
                                        endAdornment: !isHidden && (
                                            <InputAdornment position="end">
                                                <Link
                                                    className={classes.editLink}
                                                    onClick={() => handleEditClick(label as string, value as string)}
                                                    sx={{ ml: 1, cursor: "pointer", color: '#1B7EC2' }}
                                                >
                                                    Edit
                                                </Link>
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Box>
                        </Box>
                    ))}
                </Box>


                {/* Dynamic Dialog for Phone and Email */}
                <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
                    <Typography className={classes.infoLabel} sx={{ paddingLeft: '14px', paddingTop: '20px', fontSize: '20px' }}>
                        Edit Your {editField === "Phone" ? "Phone Number" : "Email Address"}
                    </Typography>
                    <Box className={classes.dividerresact} sx={{ width: '400px' }} />
                    <DialogContent>
                    <TextField
  fullWidth
  value={editValue}
  className={classes.infoValue}
  onChange={(e) => {
    let newValue = e.target.value;

    if (editField === "Phone") {
      // Allow only digits, max 10
      if (!/^\d{0,10}$/.test(newValue)) return;
    }

    setEditValue(newValue.trim()); // Trim whitespace for both phone and email
  }}
  placeholder={
    editField === "Phone"
      ? "+91 Edit New Phone Number"
      : "Edit New Email Address"
  }
  error={
    (editField === "Phone" &&
      editValue.length > 0 &&
      editValue.length !== 10) ||
    (editField === "Email" &&
      editValue.length > 0 &&
      !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(editValue))
  }
  helperText={
    editField === "Phone" && editValue.length > 0 && editValue.length !== 10
      ? "Phone number must be 10 digits"
      : editField === "Email" &&
        editValue.length > 0 &&
        !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(editValue)
      ? "Enter a valid email address"
      : ""
  }
/>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCancelClick} sx={{ color: 'black' }}>Cancel</Button>
                        <Button onClick={handleOkClick} variant="contained" color="primary">OK</Button>
                    </DialogActions>
                </Dialog>
            </Box>




            <Grid display="flex" gap="84px" marginTop="16px">
                <Box display="flex" alignItems="center" gap="4px" >
                    <Checkbox checked={hidePhone} onClick={() => setHidePhone(!hidePhone)} />
                    <Typography>Hide my phone number</Typography>
                </Box>

                <Box display="flex" alignItems="center" gap="4px">
                    <Checkbox checked={hideEmail} onClick={() => setHideEmail(!hideEmail)} />
                    <Typography>Hide my email ID</Typography>
                </Box>
            </Grid>
            <Divider className="divider" />

            <Box className={classes.inputContainer}>
                {[['Password', studentInfo.password]].map(([label, value]) => (
                    <Box key={label}>
                        <Typography sx={{ color: '#373A45!important' }} className={classes.infoLabel}>{label}</Typography>
                        <TextField
                            type="password"
                            size="small"
                            fullWidth
                            className={classes.inputField}
                            value={value}
                            disabled
                            sx={{ color: '#8C8E94 !important' }}
                            onChange={(e) => setStudentInfo({ ...studentInfo, password: e.target.value })}  // Make sure only the password is updated
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <Link
                                            className={classes.editLink}
                                            onClick={() => setIsDialogOpen(true)}
                                            sx={{ ml: 1, cursor: "pointer", color: '#1B7EC2' }}
                                        >
                                            Edit
                                        </Link>
                                    </InputAdornment>
                                ),
                            }}
                        />

                        <Dialog open={isDialogOpen} onClose={() => setIsDialogOpen(false)} fullWidth maxWidth="xs" sx={{ overflow: 'scroll' }}>
                            <Typography className={classes.infoLabel} style={{ paddingLeft: '14px', paddingTop: '20px', fontSize: '20px' }}>
                                Change Password
                            </Typography>
                            <Box className={classes.dividerresact} sx={{ width: '400px' }} />
                            <DialogContent>
                                <Typography className={classes.infoLabel} style={{ fontSize: '14px' }}>
                                    Current Password
                                </Typography>
                                <TextField

                                    type={showPassword.current ? "text" : "password"}
                                    fullWidth
                                    margin="dense"
                                    variant="outlined"
                                    placeholder="Enter Your Current Password"
                                    onChange={handleChange("currentPassword")}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton onClick={() => togglePasswordVisibility("current")}>
                                                    {showPassword.current ? <VisibilityOff /> : <Visibility />}
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                                <Typography className={classes.infoLabel} style={{ fontSize: '14px' }}>
                                    New Password
                                </Typography>
                                <TextField
                                    type={showPassword.new ? "text" : "password"}
                                    fullWidth
                                    margin="dense"
                                    variant="outlined"
                                    value={passwords.newPassword}
                                    placeholder="Enter New Password"
                                    onChange={handleChange("newPassword")}
                                    error={Boolean(errors.newPassword)}
                                    helperText={errors.newPassword}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton onClick={() => togglePasswordVisibility("new")}>
                                                    {showPassword.new ? <VisibilityOff /> : <Visibility />}
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={() => setIsDialogOpen(false)} color="inherit">Cancel</Button>
                                <Button onClick={handleDone} variant="contained">Done</Button>
                            </DialogActions>
                        </Dialog>
                    </Box>
                ))}
            </Box>

            <Box >
                <Typography className={classes.infoLabel}>
                    Health Card
                </Typography>
            </Box>
            <Box className={classes.inputContainer}>
                {[['Blood Group', studentInfo.BloodGroup],].map(([label, value]) => (
                    <Box key={label}>
                        <Typography sx={{ color: '#373A45!important' }} className={classes.infoLabel}>{label}</Typography>
                        <TextField size="small" fullWidth className={classes.inputField} value={value} disabled sx={{ color: '#8C8E94 !important' }} onChange={(e) => setStudentInfo({ ...studentInfo, [label]: e.target.value })} />
                    </Box>
                ))}
            </Box>
            <Divider className="divider" />
            <Box>
                <Typography className={classes.infoLabel}>Permanent Address</Typography>
            </Box>
            <Box className={classes.inputContainer}>
                {[
                    ['House No:', studentInfo.houseNoPermanent],
                    ['Street:', studentInfo.streetPermanent],
                    ['Suburb:', studentInfo.suburbPermanent],
                    ['City:', studentInfo.cityPermanent],
                    ['Pincode:', studentInfo.pincodePermanent]
                ].map(([label, value]) => (
                    <Box key={label}>
                        <Typography sx={{ color: '#373A45!important' }} className={classes.infoLabel}>{label}</Typography>
                        <TextField
                            size="small"
                            fullWidth
                            className={classes.inputField}
                            value={value}
                            disabled
                            sx={{ color: '#8C8E94 !important' }}
                            onChange={(e) => setStudentInfo({ ...studentInfo, [label]: e.target.value })}
                        />
                    </Box>
                ))}
            </Box>

            <Divider className="divider" />

            <Box>
                <Typography className={classes.infoLabel}>Current Address</Typography>
            </Box>
            <Box className={classes.inputContainer}>
                {[
                    ['House No:', studentInfo.houseNoCurrent],
                    ['Street:', studentInfo.streetCurrent],
                    ['Suburb:', studentInfo.suburbCurrent],
                    ['City:', studentInfo.cityCurrent],
                    ['Pincode:', studentInfo.pincodeCurrent]
                ].map(([label, value]) => (
                    <Box key={label}>
                        <Typography sx={{ color: '#373A45!important' }} className={classes.infoLabel}>{label}</Typography>
                        <TextField
                            size="small"
                            fullWidth
                            className={classes.inputField}
                            value={value}
                            disabled
                            sx={{ color: '#8C8E94 !important' }}
                            onChange={(e) => setStudentInfo({ ...studentInfo, [label]: e.target.value })}
                        />
                    </Box>
                ))}
            </Box>

            <Divider className="divider" />
            <Box >
                <Typography className={classes.infoLabel}>
                    Aadhar Details
                </Typography>
            </Box>
            <Box className={classes.inputContainer}>

                {[['Aadhar Details', studentInfo.aadharNumber]].map(([label, value]) => (
                    <Box key={label}>
                        <Typography sx={{ color: '#373A45!important' }} className={classes.infoLabel}>{label}</Typography>
                        <TextField size="small" fullWidth className={classes.inputField} value={value} disabled sx={{ color: '#8C8E94 !important' }} onChange={(e) => setStudentInfo({ ...studentInfo, [label]: e.target.value })} />
                    </Box>
                ))}
            </Box>
            <Divider className="divider" />

            <Box display="flex" justifyContent="end" alignItems="center" marginTop="16px">
                {/* Discard Changes Button */}
                <Button sx={{ color: "black" }}  onClick={handleConfirmDiscard}>
                    Cancel
                </Button>

                {/* Submit for Review Button */}
                <Button variant="contained" color="primary" onClick={handleSave}>
                    Save
                </Button>

                {/* Discard Changes Dialog */}
                <Dialog open={discardDialogOpen} onClose={() => setDiscardDialogOpen(false)}>
                    <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <Typography sx={{ fontSize: "20px", fontWeight: "500" }}>
                            Are you sure you want to discard the changes done?
                        </Typography>
                        <IconButton onClick={() => setDiscardDialogOpen(false)}>
                            <CloseIcon />
                        </IconButton>
                    </DialogTitle>

                    <DialogActions sx={{ justifyContent: "center" }}>
                        <Button
                            onClick={() => setDiscardDialogOpen(false)}
                            variant="contained"
                            sx={{ background: "#E9F2FB", boxShadow: "none", color: "black" }}
                        >
                            Cancel
                        </Button>
                        <Button
                            onClick={handleConfirmDiscard}
                            variant="contained"
                            color="primary"
                            sx={{ boxShadow: "none" }}
                        >
                            Discard Changes
                        </Button>
                    </DialogActions>
                </Dialog>

                {/* Snackbar for Success Messages */}
                <Snackbar
                    open={snackbarOpen}
                    autoHideDuration={2000}
                    onClose={() => setSnackbarOpen(false)}
                    anchorOrigin={{ vertical: "top", horizontal: "center" }} // Snackbar at top center
                >
                    <Paper
                        elevation={3}
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            backgroundColor: "white",
                            padding: "12px 16px",
                            borderRadius: "8px",
                            borderBottom: "4px solid #2E9E52",
                            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                            maxWidth: "400px",
                        }}
                    >
                        <CheckCircleIcon sx={{ color: "#2E9E52", marginRight: "8px" }} />
                        <Box>
                            <Typography fontWeight="500" color="black">
                                {snackbarMessage}
                            </Typography>

                            <Typography fontSize="14px" color="gray">
                                {snackbarDescription}
                            </Typography>

                        </Box>
                    </Paper>
                </Snackbar>
            </Box>

        </Box>
    );
};

export default EditProfile;
